<template>
    <trax-ui-ajax-table-with-crud-actions :id="id" :edit="false" :delete="allowedToDelete"
        :titles="titles" :props="props" :endpoint="endpoint" :endpoint-params="endpointParams" :bus="bus" 
    ></trax-ui-ajax-table-with-crud-actions>    
</template>

<script>
    export default {
    
        props: ['bus'],

        data: function() {
            return {
                user: user,
                endpoint: app_url+"polaris/api/front/hdv-flows",
                endpointParams: {
                    relations: ['entity']
                },
                checkEndpoint: app_url+"polaris/api/front/hdv-ops/check-all",
                titles: [
                    lang.polaris.settings.id_time,
                    lang.polaris.settings.session,
                    lang.polaris.settings.aircraft,
                    lang.polaris.settings.flight,
                    lang.polaris.settings.learner,
                    lang.polaris.settings.instructor,
                    ''
                ],
                props: [
                    {source: this.hdvId }, //order: 'updated_at'},
                    {source: this.session},
                    {source: this.aircraft},
                    {source: this.flight }, //, order: 'flight_timestamp'},
                    {source: this.learner},
                    {source: this.instructor},
                ],
                id: 'enac-custom-hdv'
            }
        },

        created: function() {
            this.bus.$on(this.id+'-delete-all-confirmed', this.deleteAll);
            this.bus.$on(this.id+'-check-all-confirmed', this.checkAll);
        },

        computed: {
            allowedToDelete() {
                return this.user.admin || this.user.permissions['hdv_flow.manage']
                    ? true      // Keep this or it will return undefined
                    : false
            }
        },

        methods: {
        
            // Columns rendering

            hdvId(data, type, row, meta) {

                let pairingClass = row.learner_state_id
                    ? 'badge badge-success'
                    : (row.has_danger ? 'badge badge-danger' : null)

                let pairingLabel = row.learner_state_id
                    ? 'sync'
                    : (row.has_danger ? 'error' : null)
                
                let html = '<small>'
                    + moment(row.updated_at).format('YYYY-MM-DD HH:mm')
                    + '<br>' + row.hdv_flow_id

                if (pairingLabel) {
                    html += '<br><span class="'+pairingClass+'">' + pairingLabel + '</span>'
                }
                
                return html
                    + '</small>'
            },

            session(data, type, row, meta) {
                return '<strong>'+lang.polaris.settings.session_type+':</strong> '+row.session_type
                    + '<br><strong>'+lang.polaris.settings.pilot_function+':</strong> '+row.pilot_function
                    + '<br><strong>'+lang.polaris.settings.hdv_training_code+':</strong> '+row.hdv_training_code
            },

            learner(data, type, row, meta) {

                let learnerClass = row.learner_id ? '' : 'bg-danger text-white px-1'

                return '<div class="'+learnerClass+'">'
                        + '<strong>'+lang.polaris.settings.name+':</strong> '+row.learner_lastname+' '+row.learner_firstname
                        + '<br><strong>'+lang.polaris.settings.enac_id+':</strong> '+row.learner_enac_id
                        + '<br><strong>'+lang.polaris.settings.emails+':</strong> '+row.learner_emails.join(', ')
                    + '</div>'
            },

            instructor(data, type, row, meta) {

                // SOLO sessions without instructor are legitimate: they are not flagged.
                let instrClass = !row.instructor_id && row.instructor_firstname
                    ? 'bg-danger text-white px-1'
                    : ''

                return '<div class="'+instrClass+'">'
                    + '<strong>'+lang.polaris.settings.name+':</strong> '+row.instructor_lastname+' '+row.instructor_firstname
                    + '<br><strong>'+lang.polaris.settings.enac_id+':</strong> '+row.instructor_enac_id
                    + '<br><strong>'+lang.polaris.settings.emails+':</strong> '+row.instructor_emails.join(', ')
            },

            aircraft(data, type, row, meta) {

                let catClass = row.unknown_aircraft_category ? 'bg-warning text-white px-1' : ''
                let typeClass = row.unknown_aircraft_type ? 'bg-warning text-white px-1' : ''

                return '<span class="'+catClass+'"><strong>'+lang.polaris.settings.aircraft_category+':</strong> '+row.aircraft_category+'</span>'
                    + '<br><span class="'+typeClass+'"><strong>'+lang.polaris.settings.aircraft_type+':</strong> '+row.aircraft_type+'</span>'
                    + '<br><strong>'+lang.polaris.settings.aircraft_registration+':</strong> '+row.aircraft_registration
            },

            flight(data, type, row, meta) {

                let centerClass = row.entity_id ? '' : 'bg-warning text-white px-1'

                let trainingCenter = row.entity
                    ? row.entity.name + ' (' + row.training_center + ')'
                    : '(' + row.training_center + ')'

                return '<strong>'+lang.polaris.settings.flight_timestamp+':</strong> '+moment(row.flight_timestamp).format('YYYY-MM-DD HH:mm')
                    + '<br><span class="'+centerClass+'"><strong>'+lang.polaris.settings.training_center+':</strong> '+trainingCenter+'</span>'
                    + '<br><strong>'+lang.polaris.settings.flight_duration+':</strong> '+(row.flight_duration / 60.0).toFixed(2)
                    + '<br><strong>'+lang.polaris.settings.tag_landing+':</strong> '+row.tag_landing
            },

            // Operations.

            deleteAll() {
                axios.delete(this.endpoint)
                    .then(response => {
                        this.bus.$emit(this.id+'-edit-updated');
                    })
                    .catch(error => {
                        this.requestError(error)
                    });
            },

            checkAll() {
                axios.post(this.checkEndpoint)
                    .then(response => {
                        this.bus.$emit(this.id+'-edit-updated');
                    })
                    .catch(error => {
                        this.requestError(error)
                    });
            },

            requestError(error) {
                var errorData = {
                    status: error.response.status, 
                    data: error.response.data, 
                }
                this.bus.$emit(this.id+'-delete-error', errorData);
                if (typeof error.response.data == 'string') {
                    this.bus.$emit(this.id+'-toastr-error', error.response.data);
                }
                if (typeof error.response.data.message == 'string') {
                    this.bus.$emit(this.id+'-toastr-error', error.response.data.message);
                }
            },
        }
    }
</script>
